import React from 'react';
import ThirdPartyJobPaymentForExportPaymentItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentForExportPaymentItem';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';

export default class ThirdPartyJobPaymentForExportPaymentAdmin extends React.Component {
  static defaultProps = {
    exportPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={ThirdPartyJobPaymentForExportPaymentItem}
          serviceFunction={ThirdPartyJobPaymentsService.GetTpEvaluatorTpJobPayments}
          convertDBItemsFunction={ThirdPartyJobPaymentsService.ConvertDBItemsForExportPayment}
          searchItem={{ ExportPaymentId: this.props.exportPaymentId }}
          orderDirection={OrderDirectionsEnum.Asc}
          showSearchStrip={false}
          errorCode='TPJPFEPA43'
        />
      </div>
    );
  }
}
